import { render, staticRenderFns } from "./vsPaginationNoSize.vue?vue&type=template&id=fc9b0c22&"
import script from "./vsPaginationNoSize.vue?vue&type=script&lang=js&"
export * from "./vsPaginationNoSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports